import axios from 'axios';
import { DOC_TYPE_WITH_EMPTY } from 'definitions/DocType';
// SsqImages 모듈은 gconf->ssqutil->SsqImages->gconf 순환 import 사슬에 들어가므로
// ssqutil은 SsqImages 자체를 import하지 않고, imgOnErrorNoImage가 필요로 하는
// no_image SVG 자산만 직접 가져온다.
import img_no_image from 'images/common/no_image.svg';
import { i18ntrans } from 'language/i18nkey';
import { LANG_EN, LANG_EN_US, LANG_KO_KR, langutil } from 'language/langutil';
import svcs from 'services';
import { ACTION_TYPES } from 'store/ActionTypes';

export const nulllist = [];
export const nullobj: any = {};
export const isVal = (v) => (v === null || v === undefined ? false : true);
export const cdnBaseUrl = `${import.meta.env.VITE_APP_BLOB_STORAGE_CDN_URL}`;

const legacyCdnBaseUrl = 'https://ssqbloblocal.blob.core.windows.net';

export const docurl = (docType: DOC_TYPE_WITH_EMPTY, docId: number, questionId?: number): string => {
  const { country, lang } = langutil.splitLangCode(svcs.svcLang.lang());
  if (['SAMPLE', 'USER_SAMPLE'].includes(docType)) {
    return `/${country}/${lang}/service/sample/document/${docId}`;
  } else if (['TECHNICAL_GUIDE', 'APPLICATION_NOTE', 'TECH_GENERAL', 'TROUBLE_SHOOTING_KNW'].includes(docType)) {
    return `/${country}/${lang}/community/blog/document/${docId}`;
  } else if (
    [
      'MANUAL',
      'CATALOG',
      'CERTIFICATION',
      'CAD_DATA',
      'DATASHEET',
      'SOFTWARE',
      'OS',
      'EDUCATION_VIDEO',
      'EDUCATION_NOTE',
      'TROUBLE_SHOOTING',
      'MARKETING_MATERIAL',
    ].includes(docType)
  ) {
    return `/${country}/${lang}/product/document/${docId}`;
  } else if (['QNA_Q'].includes(docType)) {
    return `/${country}/${lang}/community/qna/document/` + docId;
  } else if (['QNA_A'].includes(docType)) {
    return `/${country}/${lang}/community/qna/document/` + questionId;
  } else if (['SW_SERVICE'].includes(docType)) {
    return `/${country}/${lang}/service/software/document/${docId}`;
  } else if (['DOC_EVT', 'DOC_NOTI', 'TIP', 'JOB_OFFER', 'JOB_SEARCH'].includes(docType)) {
    return `/${country}/${lang}/community/board/document/` + docId;
  } else if (['RND_QNA_Q'].includes(docType)) {
    return `/${country}/${lang}/community/rnd/qna/document/` + docId;
  } else if (['RND_QNA_A'].includes(docType)) {
    return `/${country}/${lang}/community/rnd/qna/document/` + questionId;
  } else if (['RND_TALK'].includes(docType)) {
    return `/${country}/${lang}/community/rnd/talk/document/` + docId;
  } else if (['RND_NOTI'].includes(docType)) {
    return `/${country}/${lang}/community/rnd/notice/document/` + docId;
  } else if (['PARTNER_NOTI'].includes(docType)) {
    return `/${country}/${lang}/community/partner/notice/document/` + docId;
  } else if (['PARTNER_QNA_Q'].includes(docType)) {
    return `/${country}/${lang}/community/partner/qna/document/` + docId;
  } else if (['PARTNER_QNA_A'].includes(docType)) {
    return `/${country}/${lang}/community/partner/qna/document/` + questionId;
  } else if (['PTNR_SVC_DOC'].includes(docType)) {
    return `/${country}/${lang}/community/partner-v2/svc/document/${docId}`;
  }
  return `/${country}/${lang}/product/document/${docId}`;
};

export const langstr = (info: { kr: string; ww: string; us: string }) => {
  const lang = svcs.svcLang.lang();
  if (lang === LANG_KO_KR) return info.kr;
  if (lang === LANG_EN_US) return info.us;
  if (lang === LANG_EN) return info.ww;
  return info.ww;
};

export const iskr = () => {
  if (svcs.svcLang.lang() === LANG_KO_KR) return true;
  return false;
};
export const isus = () => {
  if (svcs.svcLang.lang() === LANG_EN_US) return true;
  return false;
};

export const isww = () => {
  if (svcs.svcLang.lang() === LANG_EN) return true;
  return false;
};
export const ssqutil = {
  toarray: (obj: any) => {
    if (!obj) return obj;
    if (Array.isArray(obj)) return obj;
    return [obj];
  },
  loading: (loading: boolean) => {
    return { type: ACTION_TYPES.MAIN.LOADING, payload: loading };
  },
  lang: () => {
    return svcs.svcLang.lang();
  },
  isMobile: () => {
    if (window.matchMedia('screen and (max-width: 764px)').matches) {
      return true;
    } else {
      return false;
    }
  },
  isProduction: () => {
    // Vite: import.meta.env.PROD is true in production mode
    return import.meta.env.PROD;
  },
  isLocal: () => {
    // Vite: import.meta.env.MODE is 'localhost' when running with --mode localhost
    return import.meta.env.MODE === 'localhost';
  },
  imgOnErrorNoImage: (e) => {
    e.target.src = img_no_image;
    e.target.className = 'no-image';
    e.target.alt = 'no_image.svg';
  },
  download: (content, filename, contentType?) => {
    // contentType = "text/csv;charset=utf-8;";
    // contentType = "application/octet-stream;charset=utf-8;";
    // contentType = "text/html; charset=utf-8;";
    if (!contentType) contentType = 'application/octet-stream;charset=utf-8;';
    let a = document.createElement('a');
    let blob = new Blob([`\ufeff${content}`], { type: contentType });
    //var blob = new Blob(["\uefbbbf" + content], { type: contentType });
    a.href = window.URL.createObjectURL(blob);
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(a.href);
  },
  downloadurl: (url, filename, timeout = 5) => {
    let a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('download', filename);
    //a.setAttribute('_target', '');
    // a.href = url;
    // a.download = filename;
    document.body.appendChild(a);

    a.target = '';
    a.click();
    ///setTimeout(() => document.body.removeChild(a), timeout * 1000 * 60);
    //document.body.removeChild(a);
    //a.parentNode.removeChild(a);
  },
  snakeToCamel: (str) =>
    str.toLowerCase().replace(/([-_][a-z0-9])/g, (group) => group.toUpperCase().replace('-', '').replace('_', '')),
  geturllasttok: (url: string) => {
    let a = (url || '').split('/');
    if (a.length === 0) return '';
    return a.slice(-1)[0];
  },
  base64font: (): Promise<string> => {
    return axios.get('/fonts/malgun.ttf', { responseType: 'blob' }).then((res) => {
      return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const result = reader.result as string;
          const base64 = result.slice(result.indexOf(',') + 1);
          resolve(base64);
        };
        reader.readAsDataURL(res.data);
      });
    });
  },
  base64fontbold: (): Promise<string> => {
    //return axios.get('/fonts/SpoqaHanSansNeo-Bold.ttf', {responseType: 'blob'}).then(res => {
    return axios.get('/fonts/NotoSansKR-Bold.ttf', { responseType: 'blob' }).then((res) => {
      return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const result = reader.result as string;
          const base64 = result.slice(result.indexOf(',') + 1);
          resolve(base64);
        };
        reader.readAsDataURL(res.data);
      });
    });
  },
  base64fontmedium: (): Promise<string> => {
    //return axios.get('/fonts/SpoqaHanSansNeo-Medium.ttf', {responseType: 'blob'}).then(res => {
    return axios.get('/fonts/NotoSansKR-Medium.ttf', { responseType: 'blob' }).then((res) => {
      return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const result = reader.result as string;
          const base64 = result.slice(result.indexOf(',') + 1);
          resolve(base64);
        };
        reader.readAsDataURL(res.data);
      });
    });
  },
  base64fontregular: (): Promise<string> => {
    //return axios.get('/fonts/SpoqaHanSansNeo-Regular.ttf', {responseType: 'blob'}).then(res => {
    return axios.get('/fonts/NotoSansKR-Regular.ttf', { responseType: 'blob' }).then((res) => {
      return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const result = reader.result as string;
          const base64 = result.slice(result.indexOf(',') + 1);
          resolve(base64);
        };
        reader.readAsDataURL(res.data);
      });
    });
  },
  copyToClipboard(str: string): boolean {
    const trans = i18ntrans.community;
    if (!document.queryCommandSupported('copy')) {
      alert(trans('I18N_BROWSER_DOES_NOT_SUPPORT'));
      return false;
    }

    let dummy = document.createElement('input');
    let text = str;

    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
    //window.alert(trans('I18N_URL_COPIED_TO_CLIPBOARD'));
    return true;
  },
  getBlobUrlForLargeFile(url: string) {
    if (!(url || '').startsWith(legacyCdnBaseUrl)) {
      return url;
    }
    return url.replace(legacyCdnBaseUrl, cdnBaseUrl);
  },
  getCdnUrl(url: string) {
    if ((url || '').startsWith(legacyCdnBaseUrl)) {
      return url.replace(legacyCdnBaseUrl, cdnBaseUrl);
    }
    if ((url || '').startsWith('/')) {
      return cdnBaseUrl + url;
    }
    if (!url) return '';
    return cdnBaseUrl + '/' + url;
  },
  isVal,
  getHHP: () => {
    return `${window.location.protocol}://${window.location.host}`;
  },
};

export const isstr = (v): v is string => {
  if (typeof v === 'string') return true;
  return false;
};

export const isPathStartsWith = (path: string, startsWith: string) => {
  if (path.startsWith(startsWith)) return true;
  if (/^\/\w\w\/\w\w\//.test(path)) {
    if (path.substring(6).startsWith(startsWith)) return true;
  }
  return false;
};

/**
 * AI Chatbot v2 위젯 열기. 기존 진입점(메인메뉴 / 퀵링크의 AI 챗봇)이 호출한다.
 *
 * 아래 두 경로 모두 벤더 위젯의 **공식 계약이 아닌 실측 확인된 동작**에 의존한다.
 * (벤더가 마크업/파라미터 지원을 바꾸면 깨질 수 있음 — 공식 open API/selector 확보 시 교체 권장.)
 * 1순위: 위젯이 이미 로드돼 있으면 자체 런처 버튼을 클릭해 **새로고침 없이** 연다.
 *   (런처는 위젯 루트 `#lse-electric-ai-chatbot-root`의 첫 번째 버튼 — 로케일 독립 선택.
 *    이미 열린 상태에서 재클릭해도 닫히지 않음(idempotent) — 실측.)
 * 2순위(폴백): 위젯 DOM이 아직 없으면(스크립트 미로드 등) 현재 URL에 `ai_chat=open`을
 *   붙여 네비게이션 — 위젯이 로드 시 이 파라미터를 읽어 자동으로 연다(실측 확인).
 */
export function openAiChatWidget() {
  const launcher = document.getElementById('lse-electric-ai-chatbot-root')?.querySelector('button');
  if (launcher) {
    (launcher as HTMLButtonElement).click();
    return;
  }
  const url = new URL(window.location.href);
  url.searchParams.set('ai_chat', 'open');
  window.location.href = url.toString();
}

export function openChatBot(url: string) {
  var wt = screen.width,
    ht = screen.height,
    left = Math.floor((wt - 360) / 2),
    top = Math.floor((ht - 651) / 2);
  window.open(
    url,
    '_blank',
    'width=' +
      360 +
      ',height=' +
      651 +
      ',left=' +
      left +
      ',top=' +
      top +
      ',history=no,resizable=no,status=no,scrollbars=yes,menubar=no'
  );
}
